module.exports = __webpack_public_path__ + "h5/img/rijin_red.53e7c3eb.png";